import moment from 'moment'

export const formatTime = (time: number) => {
  const minutes = Math.floor(time / 60)
  const seconds = Math.floor(time % 60)
  
  return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
}

export const normalizeDate = (date: Date) => {
  if (!date) return null
  return new Date(date).toISOString().replace('Z', '+00:00')
}

/**
 * Formats date string to dd.mm.yyyy hh:mm format
 * @param dateString - ISO date string or any valid date format
 * @returns formatted date string in DD.MM.YYYY HH:mm format
 */
export const formatDate = (dateString: string) => {
  return moment(dateString).format('DD.MM.YYYY HH:mm')
}